import { questionnaireTemplateApi } from '@/lib/api/questionnaireApi';
import {
  QuestionnaireTemplateDetailProps,
  QuestionnaireTemplateProps,
} from '@/types/questionnaire';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export default function useQuestionnaireTemplate({
  templates,
}: {
  templates: QuestionnaireTemplateProps[];
}) {
  const [currentTemplateId, setCurrentTemplateId] = useState<number | null>(
    templates.length ? templates[0].id : null
  );

  const {
    data: currentTemplateData,
    isLoading,
    error,
  } = useQuery<QuestionnaireTemplateDetailProps>({
    queryKey: ['template', currentTemplateId],
    queryFn: () => questionnaireTemplateApi.getById(currentTemplateId!),
    enabled: currentTemplateId !== null,
  });

  return {
    currentTemplateData,
    isTemplateLoading: isLoading,
    currentTemplateId,
    setCurrentTemplateId,
    error,
  };
}
